// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1F9Gx","selected":"Chip_selected__2NWIT"};